export const DELIVERY_FEE_ZAR = 99;
